module.exports = __webpack_public_path__ + "assets/Beta.152fab31bd96bbe7366332d931431fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Beta.png
// module id = 781
// module chunks = 0